import { useEffect, useState } from "react";

import { siteConfig } from "../../content/site";

function supportsIntersectionObserver() {
  return (
    typeof window !== "undefined" &&
    typeof window.IntersectionObserver === "function"
  );
}

export function MobilePhoneCTA() {
  const [isVisible, setIsVisible] = useState(
    () => !supportsIntersectionObserver(),
  );

  useEffect(() => {
    const primaryPhoneCta = document.querySelector(
      '[data-testid="primary-phone-cta"]',
    );

    if (!primaryPhoneCta || !supportsIntersectionObserver()) {
      queueMicrotask(() => setIsVisible(true));
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(!entry.isIntersecting);
      },
      { threshold: 0.01 },
    );

    observer.observe(primaryPhoneCta);
    return () => observer.disconnect();
  }, []);

  return (
    <aside
      className={`mobile-phone-cta${isVisible ? " is-visible" : ""}`}
      data-review-region="mobile-phone-cta"
      aria-label="電話査定への固定案内"
      aria-hidden={!isVisible}
    >
      <a
        href={siteConfig.phoneHref}
        data-testid="mobile-phone-cta-link"
        tabIndex={isVisible ? undefined : -1}
        aria-label={`松島オートへ電話で3分査定を相談する。電話番号 ${siteConfig.phoneDisplay}`}
      >
        <span>電話で3分査定</span>
        <strong>{siteConfig.phoneDisplay}</strong>
      </a>
    </aside>
  );
}
